import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { getToken } from "../../../Utils/Common";
import { ShowMessage } from "../../../Utils/show-message";

function CreateBook() {
  const [error, setError] = useState([]);
  const [sucessMessage, setsucessMessage] = useState("");
  const navigate = useNavigate();
  const [status, setStatus] = useState("");
  const [message, setMessage] = useState("");

  const token = getToken();

  const [state, setState] = React.useState({
    id: "",
    title: "",
    description: "",
    book_author: "",
    narrated_by: "",
    hour: "",
    minute: "",
    difficulty_level: "",
    image_path: "",
    book_audio: "",
    sample_text: "",
  });

  const options = [
    {
      label: "Easy",
      value: "Easy",
    },
    {
      label: "Medium",
      value: "Medium",
    },
    {
      label: "Hard",
      value: "Hard",
    },
    // {
    //   label: "Pineapple",
    //   value: "pineapple",
    // },
  ];

  const handleChange = (event) => {
    const value = event.target.value;
    console.log(value);
    setState({
      ...state,
      [event.target.name]: value,
    });
  };

  const handleFileChange = (event) => {
    const value = event.target.files[0];
    setState({
      ...state,
      [event.target.name]: value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setError(null);
    setsucessMessage("");

    var formData = new FormData();
    formData.append("title", state.title);
    formData.append("author", state.book_author);
    formData.append("narrated_by", state.narrated_by);
    formData.append("hours", state.hour);
    formData.append("minutes", state.minute);
    formData.append("description", state.description);
    formData.append("difficulty", state.difficulty_level);
    formData.append("book_image", state.book_image);
    formData.append("sample_audio", state.book_audio);
    formData.append("sample_text", state.sample_text);

    for (var key of formData.entries()) {
      formData[key[0]] = key[1];
      // console.log(formData);
    }

    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}v1/admin/book`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: formData,
    })
      .then((response) => {
        // console.log(response.data.message);
        if (response.status === 200) {
          // setsucessMessage(response.data.message);
          setStatus(200);
          setMessage(response.data.message);
          Array.from(document.querySelectorAll("input")).forEach(
            (input) => (input.value = "")
          );

          Array.from(document.querySelectorAll("textarea")).forEach(
            (input1) => (input1.value = "")
          );

          Array.from(document.querySelectorAll("select")).forEach(
            (input2) => (input2.value = "")
          );
          // console.log(response);
        }
      })
      .catch((error) => {
        if (error.response.status === 422) {
          // console.log(error.response);
          setError(error.response.data.message);
          setStatus(422);
          setMessage(error.response.data.message);
        } else if (error.response.status === 500) {
          console.log(error.response);
          setStatus(500);
          setMessage("Something went wrong. Please try again later.");
          // setError("Something went wrong. Please try again later.");
        } else {
          // console.log(error.response);
          setMessage("Something went wrong. Please try again later.");
          // setError("Something went wrong. Please try again later.");
        }
        // console.log(error.response);
      });
  };

  return (
    <>
      <div
        className="d-flex flex-column flex-root"
        style={{ marginTop: "140px" }}
      >
        <div
          className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed"
          style={{
            backgroundImage: "url(assets/media/illustrations/sketchy-1/14.png",
          }}
        >
          <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
            {/* <button
            className="btn btn-lg btn-primary"
            onClick={() => navigate(-1)}
          >
            go back
          </button> */}
            <div className="w-lg-1000px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto">
              <ul className="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                <li
                  className="breadcrumb-item text-muted"
                  style={{ fontSize: "15px" }}
                >
                  <Link to={`/admin/books`}>Books</Link>
                </li>

                <li className="breadcrumb-item" style={{ fontSize: "15px" }}>
                  <span className="bullet bg-gray-300 w-5px h-2px" />
                </li>

                <li
                  className="breadcrumb-item text-dark"
                  style={{ fontSize: "15px" }}
                >
                  Create Book
                </li>
              </ul>

              <p style={{ color: "green", fontSize: "20px" }}>
                {sucessMessage}
              </p>

              <ShowMessage status={status} message={message} />
              <form
                className="form w-100"
                // noValidate="novalidate"
                method="POST"
                onSubmit={handleSubmit}
              >
                <div className="text-center mb-10">
                  <h1 className="link-primary fw-bolder"> Lingonovel </h1>
                  <h1 className="text-dark mb-3"> Add Book </h1>
                  {/* <button onClick={() => history.goBack()}>Back</button> */}
                  {/* <div className="text-gray-400 fw-bold fs-4">
                    Already have an account?
                    <Link to="/login" className="link-primary fw-bolder">
                      Sign in here
                    </Link>
                  </div> */}
                </div>
                <p style={{ color: "red" }}>{error ? error : ""}</p>

                <div className="fv-row mb-10">
                  <label className="form-label fs-6 fw-bolder text-dark">
                    Book Title
                  </label>
                  <input
                    className="form-control form-control-lg form-control-solid"
                    type="text"
                    name="title"
                    id="title"
                    placeholder="Book Title"
                    onChange={handleChange}
                    autoComplete=""
                    required
                  />
                  {/* <p style={{ color: "red" }}>
                  {error.title !== undefined && error.title[0]
                    ? error.title[0]
                    : ""}
                </p> */}
                </div>

                <div className="fv-row mb-10">
                  <label className="form-label fs-6 fw-bolder text-dark">
                    Book Description
                  </label>
                  <textarea
                    className="form-control form-control-lg form-control-solid"
                    type="text"
                    name="description"
                    id="description"
                    placeholder="Book Description"
                    onChange={handleChange}
                    required
                    rows="4"
                    cols="50"
                    autoComplete="true"
                  />
                  {/* <p style={{ color: "red" }}>
                  {error.description !== undefined && error.description[0]
                    ? error.description[0]
                    : ""}
                </p> */}
                </div>

                <div className="fv-row mb-10">
                  <div className="d-flex flex-stack mb-2">
                    <label className="form-label fw-bolder text-dark fs-6 mb-0">
                      Book Author
                    </label>
                    {/*end::Link*/}
                  </div>
                  {/*end::Wrapper*/}
                  {/*begin::Input*/}
                  <input
                    className="form-control form-control-lg form-control-solid"
                    type="text"
                    name="book_author"
                    id="book_author"
                    placeholder="Book Author"
                    onChange={handleChange}
                    required
                    autoComplete=""
                  />
                  {/* <p style={{ color: "red" }}>
                  {error.book_author !== undefined && error.book_author[0]
                    ? error.book_author[0]
                    : ""}
                </p> */}
                  {/*end::Input*/}
                </div>

                <div className="fv-row mb-10">
                  <div className="d-flex flex-stack mb-2">
                    <label className="form-label fw-bolder text-dark fs-6 mb-0">
                      Narrated By
                    </label>
                    {/*end::Link*/}
                  </div>
                  {/*end::Wrapper*/}
                  {/*begin::Input*/}

                  <input
                    className="form-control form-control-lg form-control-solid"
                    type="text"
                    name="narrated_by"
                    id="narrated_by"
                    placeholder="Narrated By"
                    onChange={handleChange}
                    required
                  />
                  {/*end::Input*/}
                </div>

                <div className="fv-row mb-10">
                  <div className="d-flex flex-stack mb-2">
                    <label className="form-label fw-bolder text-dark fs-6 mb-0">
                      Book Sample Text
                    </label>
                    {/*end::Link*/}
                  </div>
                  {/*end::Wrapper*/}
                  {/*begin::Input*/}

                  <input
                    className="form-control form-control-lg form-control-solid"
                    type="text"
                    name="sample_text"
                    id="sample_text"
                    placeholder="Book Sample Text"
                    onChange={handleChange}
                    required
                  />
                  {/*end::Input*/}
                </div>

                <div className="fv-row mb-5">
                  <div className="d-flex flex-stack mb-2">
                    <label className="form-label fw-bolder text-dark fs-6 mb-0">
                      Hours
                    </label>
                    {/*end::Link*/}
                  </div>
                  {/*end::Wrapper*/}
                  {/*begin::Input*/}
                  <input
                    className="form-control form-control-lg form-control-solid"
                    type="integer"
                    name="hour"
                    id="hour"
                    placeholder="Hours"
                    onChange={handleChange}
                    required
                  />
                  {/*end::Input*/}
                </div>

                <div className="fv-row mb-5">
                  <div className="d-flex flex-stack mb-2">
                    <label className="form-label fw-bolder text-dark fs-6 mb-0">
                      Minutes
                    </label>
                    {/*end::Link*/}
                  </div>

                  <input
                    className="form-control form-control-lg form-control-solid"
                    type="integer"
                    name="minute"
                    id="minute"
                    placeholder="Minutes"
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="fv-row mb-10">
                  <div className="d-flex flex-stack mb-2">
                    <label
                      className="form-label fw-bolder text-dark fs-6 mb-0"
                      htmlFor="levels"
                    >
                      Choose a level:
                    </label>

                    {/*end::Link*/}
                  </div>
                  {/*end::Wrapper*/}
                  {/*begin::Input*/}

                  <select
                    className="form-control form-control-lg form-control-solid"
                    name="difficulty_level"
                    id="difficulty_level"
                    // value="easy"
                    value={state.easy}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Level</option>
                    {options.map((option, index) => (
                      <option value={option.value} key={index}>
                        {option.label}
                      </option>
                    ))}
                    {/* <option value="">Select Level</option> */}
                    {/* <option value="easy">Easy</option>
                  <option value="medium">Medium</option>
                  <option value="hard">Hard</option> */}
                  </select>
                  {/*end::Input*/}
                </div>

                <div className="fv-row mb-10">
                  <div className="d-flex flex-stack mb-2">
                    <label className="form-label fw-bolder text-dark fs-6 mb-0">
                      Upload Book Cover Image
                    </label>
                    {/*end::Link*/}
                  </div>
                  {/*end::Wrapper*/}
                  {/*begin::Input*/}
                  <input
                    className="form-control form-control-lg form-control-solid"
                    type="file"
                    // value="upload image here.."
                    name="book_image"
                    id="book_image"
                    placeholder="Upload Image"
                    onChange={handleFileChange}
                    required
                  />
                  {/*end::Input*/}
                </div>

                <div className="fv-row mb-10">
                  <div className="d-flex flex-stack mb-2">
                    <label className="form-label fw-bolder text-dark fs-6 mb-0">
                      Upload Book Audio
                    </label>
                    {/*end::Link*/}
                  </div>
                  {/*end::Wrapper*/}
                  {/*begin::Input*/}
                  <input
                    className="form-control form-control-lg form-control-solid"
                    type="file"
                    name="book_audio"
                    id="book_audio"
                    onChange={handleFileChange}
                    required
                  />
                  {/*end::Input*/}
                </div>
                {/*end::Input group*/}
                {/*begin::Actions*/}
                <div className="text-center">
                  {/*begin::Submit button*/}
                  <button type="submit" className="btn btn-lg btn-primary">
                    <span className="indicator-label"> Submit </span>
                  </button>
                  {/*end::Separator*/}
                </div>
                {/*end::Actions*/}
              </form>
              {/*end::Form*/}
            </div>
            {/*end::Wrapper*/}
          </div>
          {/*end::Content*/}
          {/*begin::Footer*/}
          <div className="d-flex flex-center flex-column-auto p-10">
            {/*begin::Links*/}
            <div className="d-flex align-items-center fw-bold fs-6">
              <a href="/#" className="text-muted text-hover-primary px-2">
                About
              </a>
              <a href="/#" className="text-muted text-hover-primary px-2">
                Contact
              </a>
              <a href="/#" className="text-muted text-hover-primary px-2">
                Contact Us
              </a>
            </div>
            {/*end::Links*/}
          </div>
          {/*end::Footer*/}
        </div>
        {/*end::Authentication - Sign-in*/}
      </div>
    </>
  );
}

export default CreateBook;
